/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.real-estate\":\"Hus med en trädgård\"}");